export default "__VITE_PUBLIC_ASSET__097d2847__"